"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-lazzaro-di-savena": {
    "db6d46d8": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "skipSearch": false
    }],
    "botteghino-di-zocca": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "59e559a1": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-mandorli": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c4128cd": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "skipSearch": false
    }],
    "pianoro": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3cbfc658": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-savena": [{
      "hkey": "7c3da19c",
      "slug": "san-lazzaro-di-savena",
      "name": "San Lazzaro di Savena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86bfc7df": [{
      "hkey": "5127e3d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-lazzaro-centro": [{
      "hkey": "5127e3d4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;